import { useEffect } from 'react';
import { tryReloadForStaleChunk } from '../utils/staleChunkLoadError';

function ErrorBoundary({ children }) {
  useEffect(() => {
    const handleError = (event: PromiseRejectionEvent) => {
      const reason = String(event.reason ?? '');
      if (reason.includes('because its MIME type')) {
        window.location.reload();
        return;
      }
      tryReloadForStaleChunk(event.reason);
    };

    window.addEventListener('unhandledrejection', handleError);
    return () => {
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, []);

  return children;
}

export default ErrorBoundary;
